// Load complete module with all charts
import VueCharts from 'vue-chartjs'

export default {
  extends: VueCharts.Pie,
  mixins: [VueCharts.mixins.reactiveProp],
  props: ['chartData', 'options'],
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
}



// WEBPACK FOOTER //
// ./src/shared/components/charts/PieChart.js